import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-white/10 px-5 pb-8 pt-24 lg:px-10" data-testid="site-footer">
      <div className="grid gap-12 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <p className="text-xs uppercase tracking-[0.28em] text-zinc-500">BKG Global</p>
          <h2 className="mt-4 font-heading text-[clamp(4rem,14vw,15rem)] font-black italic leading-[0.75] tracking-[-0.08em] text-outline">BKG GLOBAL</h2>
        </div>
        <div className="flex flex-col justify-end gap-4 text-sm text-zinc-400">
          <a data-testid="footer-collection-link" href="#shop" className="transition-colors hover:text-volt">Collection</a>
          <a data-testid="footer-manifesto-link" href="#manifesto" className="transition-colors hover:text-volt">Manifesto</a>
          <Link data-testid="footer-admin-link" to="/admin" className="transition-colors hover:text-volt">Admin studio</Link>
        </div>
      </div>
      <div className="mt-16 flex flex-col justify-between gap-4 border-t border-white/10 pt-6 text-xs uppercase tracking-[0.22em] text-zinc-600 sm:flex-row">
        <span>© 2026 BKG Global</span>
        <span>Fashion / Electronics / Objects</span>
      </div>
    </footer>
  );
}
